import * as Types from './types';
import {
  expectedErrorTextForFailedSignIn,
  internalServerErrorMessage,
  unknownErrorMessage,
  failedToSendEmailVerificationMessage,
} from './error-message-text';

export const signIn = (
  email: string,
  password: string,
): { type: string; payload: { email: string; password: string } } => ({
  type: Types.SIGN_IN_SAGA,
  payload: {
    email,
    password,
  },
});

export const signInSuccess = (
  userId: string,
  email: string | null = null,
): { type: string; payload: { userId: string; email: string | null } } => ({
  type: Types.SIGN_IN_SUCCESS,
  payload: {
    userId,
    email,
  },
});

export const signInUnauthorized = (): { type: string; payload: string } => ({
  type: Types.SIGN_IN_UNAUTHORIZED,
  payload: expectedErrorTextForFailedSignIn,
});

export const signInInternalServerError = (): { type: string; payload: string } => ({
  type: Types.SIGN_IN_INTERNAL_SERVER_ERROR,
  payload: internalServerErrorMessage,
});

export const signInUnknownError = (): { type: string; payload: string } => ({
  type: Types.SIGN_IN_UNKNOWN_ERROR,
  payload: unknownErrorMessage,
});

export const signInPartialSuccessEmailNotVerified = (
  userId: string,
  email: string | null = null,
): { type: string; payload: { userId: string; email: string | null } } => ({
  type: Types.SIGN_IN_PARTIAL_SUCCESS_EMAIL_NOT_VERIFIED,
  payload: { userId, email },
});

export const signInVerficationEmailFailedToSend = (): { type: string; payload: string } => ({
  type: Types.SIGN_IN_VERIFICATION_EMAIL_FAILED_TO_SEND,
  payload: failedToSendEmailVerificationMessage,
});

export const signOut = (): { type: string } => ({
  type: Types.SIGN_OUT_SAGA,
});
